/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { ICON_CHEVRON_LEFT, ICON_MENU_OPEN } from '../../../../Icons';
import { SdsIcon } from '../../../SdsIcon';
import { SourceLauncherProps } from './SourceLauncher.props';

/**
 * SDS source launcher component.
 */
export const SourceLauncher = (props: SourceLauncherProps): JSX.Element => {
  const { accessibleProps, buttonId, placeholderText, selectedSource } = props;

  return (
    <button
      {...accessibleProps}
      aria-label="Open source selector"
      className="sds-source-selector__launcher"
      id={buttonId}
    >
      <div className="sds-source-selector__icon">
        <SdsIcon svg={selectedSource?.icon ?? ICON_MENU_OPEN} />
      </div>
      <span>{selectedSource?.name ?? placeholderText}</span>
      <div className="sds-source-selector__chevron">
        <SdsIcon svg={ICON_CHEVRON_LEFT} />
      </div>
    </button>
  );
};
